module.exports = __webpack_public_path__ + "img/succeed.377e5564.png";